// removed by extract-text-webpack-plugin
module.exports = {"fair-box-content":"fair-box-content","title-content":"title-content","item-detail":"item-detail","title":"title","value":"value"};


//////////////////
// WEBPACK FOOTER
// ./components/fair/_FairDetail.scss
// module id = ./components/fair/_FairDetail.scss
// module chunks = 0